module.exports = __webpack_public_path__ + "static/img/IMG_20240209_164724.e3aa0333.jpg";